module.exports = __webpack_public_path__ + "img/2.647bd482.png";